export default {
  getUserToken: function() {
    const we_user_token = localStorage.getItem("BYWN_TOKEN");
    return we_user_token && typeof we_user_token !== "undefined"
      ? we_user_token
      : "";
  },
  setUserToken: function(we_user_token) {
    localStorage.setItem("BYWN_TOKEN", we_user_token);
  },
  clearUserToken: function() {
    localStorage.removeItem("BYWN_TOKEN");
  }
};
